import store from '@/store';
import Cookies from 'js-cookie';
import { encrypte } from './crypto';
import { loadTranslations } from './translate';
import { deviceInterfaceLanguage } from './deviceLanguage.mjs';

export const interfaceLanguages = Object.freeze({ pt: 'Português', es: 'Español', en: 'English' });
const preferenceKey = 'jobifull.ui-language.v1';
let selectionRevision = 0;

export function explicitInterfaceLanguage() {
    try {
        const iso = window.localStorage.getItem(preferenceKey);
        if (Object.hasOwn(interfaceLanguages, iso)) return iso;
    } catch (_) { /* The explicit cookie also works when storage is blocked. */ }
    try {
        const iso = Cookies.get('uiLanguageChoice');
        return Object.hasOwn(interfaceLanguages, iso) ? iso : null;
    } catch (_) { return null; }
}

export function interfaceLanguageRevision() { return selectionRevision; }

export function initialInterfaceLanguage() {
    return explicitInterfaceLanguage() || deviceInterfaceLanguage();
}

export async function selectInterfaceLanguage(iso, { isCurrent = () => true } = {}) {
    if (!Object.hasOwn(interfaceLanguages, iso)) throw new Error('Unsupported interface language');
    if (!isCurrent()) return false;
    const revision = ++selectionRevision;
    await loadTranslations(iso, { requireCatalogue: true });
    if (revision !== selectionRevision || !isCurrent()) return false;
    await store.dispatch('changeLanguage', { langIso: iso, langName: interfaceLanguages[iso] });
    const options = { expires: 365, path: '/', sameSite: 'Lax', secure: window.location.protocol === 'https:' };
    Cookies.set('userLang', encrypte(iso), options);
    Cookies.set('langName', encrypte(interfaceLanguages[iso]), options);
    Cookies.set('uiLanguageChoice', iso, options);
    try { window.localStorage.setItem(preferenceKey, iso); } catch (_) { /* Cookies remain the fallback. */ }
    store.dispatch('setAlreadyChangedLanguageByIp', true);
    store.dispatch('cleanDataChest', {});
    store.dispatch('cleanComboChest', {});
    return true;
}
